import { defineMessages } from 'react-intl';

export default defineMessages({
    savedQuote: {
        id: 'ml.quoteandbind.common.footer.Weve Saved Your Quote',
        defaultMessage: 'We\'ve Saved Your Quote'
    },
    sendQuote: {
        id: 'ml.quoteandbind.common.footer.Send Me My Quote Number',
        defaultMessage: 'Send Me My Quote Number'
    },
    sendQuoteEmailOrText: {
        id: 'ml.quoteandbind.common.footer.Send quote number by email or text?',
        defaultMessage: 'Send quote number by email or text?'
    },
    sendQuoteEmail: {
        id: 'ml.quoteandbind.common.footer.Send quote number by email?',
        defaultMessage: 'Send quote number by email?'
    },
    email: {
        id: 'ml.quoteandbind.common.footer.Email',
        defaultMessage: 'Email'
    },
    text: {
        id: 'ml.quoteandbind.common.footer.Text',
        defaultMessage: 'Text'
    },
    validEmail: {
        id: 'ml.quoteandbind.common.footer.Enter a valid email',
        defaultMessage: 'Enter a valid email'
    },
    send: {
        id: 'ml.quoteandbind.common.footer.SEND',
        defaultMessage: 'SEND'
    },
    policyNumber: {
        id: 'ml.quoteandbind.common.footer.Your Policy Number Is',
        defaultMessage: 'Your Policy Number Is'
    },
    thankyou: {
        id: 'ml.quoteandbind.common.footer.Thank you',
        defaultMessage: 'Thank you'
    },
    emailSent: {
        id: 'ml.quoteandbind.common.footer.An email with your quote number has been sent',
        defaultMessage: 'An email with your quote number has been sent to {target}'
    },
    textSent: {
        id: 'ml.quoteandbind.common.footer.A text with your quote number has been sent',
        defaultMessage: 'A text with your quote number has been sent to {target}'
    },
    continue: {
        id: 'ml.quoteandbind.common.footer.Continue',
        defaultMessage: 'Continue'
    }
});
